// extracted by mini-css-extract-plugin
export default {"fullWidth":"Eh-z","hasStyledAspectRatio":"Fh-z"};